<template>
    <div>
        <div class="layout-right bg mb16">
            <Form :label-width="110">
                <Row :gutter="24">
                    <Col span="8">
                        <Form-item label="投保单号">
                            <Input v-model.trim="params.billNo" clearable placeholder="请输入投保单号" @on-enter="tabChange"></Input>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="投保单状态">
                            <Select v-model="params.status" clearable>
                                <Option v-for="(item,index) in insuranceStatusList" :value="item.value" :key="index">{{ item.label }}</Option>
                            </Select>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="投保单创建时间">
                            <daterange @on-change="val=>{setDateRange(val,'createTime')}" isFulltime placeholder="请选择创建时间" placement="bottom-end"></daterange>
                        </Form-item>
                    </Col>
                    <Col span="24" class="right">
                        <Button type="primary" @click="tabChange">搜索</Button>
                        <Button type="primary" @click="exportToExcel('/casual/insurance/list/export',params)">导出</Button>
                    </Col>
                </Row>
            </Form>
        </div>
        <div class="layout-right bg">
            <i-table :columns="columns" url="/casual/insurance/list.json" :params="params" ref="table">
                <template slot-scope="{ row }" slot="action">
                    <Dropdown transfer>
                        <a href="javascript:void(0)">
                            管理
                            <Icon type="ios-arrow-down"></Icon>
                        </a>
                        <Dropdown-menu slot="list">
                            <Dropdown-item name="查看详情" @click.native="toDetail(row)" style="text-align: center;">
                                <a>查看详情</a>
                            </Dropdown-item>
                            <Dropdown-item @click.native="toEdit(row)" style="text-align: center;">
                                <a>重新投保</a>
                            </Dropdown-item>
                            <Dropdown-item v-if="row.status=='1'" @click.native="toconfirm(row)" style="text-align: center;">
                                <a>确认</a>
                            </Dropdown-item>
                        </Dropdown-menu>
                    </Dropdown>
                </template>
            </i-table>
        </div>
    </div>
    </template>
    <script>
    import ITable from '@/components/common/ITable'
    import daterange from '@/components/common/daterange'
    export default {
        components:{ ITable,daterange },
        data () {
            return {
                loading: false,
                params: {},
                columns: [
                    {title:'投保单号',key:'billNo',width: 260,fixed: 'left'},
                    {title:'险种',key:'insuranceName',minWidth: 180,ellipsis: true,tooltip: true},
                    {title:'保障方案',key:'insurancePlanName',minWidth: 180,ellipsis: true,tooltip: true},
                    {title:'投保单创建时间',key:'createTime',width: 180},
                    {title:'状态',key:'statusName',minWidth: 120},
                    {
                        title: '操作',
                        slot: 'action',
                        width: 90,
                        fixed: 'right'
                    }
                ],
                insuranceStatusList: [
                    { value: 1, label: '待确认' },
                    { value: 2, label: '已完成' },
                    { value: 3, label: '已过期' }
                ]
            }
        },
        computed:{
        },
        created () {
        },
        methods:{
            excel () {
                this.exportToExcel("/specialEquipment/insurance/export",this.params);
            },
            tabChange(){
                this.$refs.table.getList()
            },
            toDetail(row){
                this.$router.push({
                    path:`/my/customizedLineWork/insuranceDetail/${row.billNo}`
                })
            },
            toEdit(row){
                this.$router.push({
                    path:`/lineWork/fillin/${row.billNo}?reset=NEW`
                })
            },
            toconfirm(row){
                sessionStorage.removeItem("track_session_key")
                this.$router.push('/lineWork/confirm/'+row.billNo);
            },
            setDateRange (val,key) {
                this.params[key+"Begin"] = val[0];
                this.params[key+"End"] = val[1];
            }
        }
    };
</script>
<style lang="less" scoped>
    .policy{
		display:flex;
        flex-wrap: wrap;
	}
	.policy-item{
		margin-right: 15px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedLineWork/insurance/index.vue